<div class="members-page">
  <!-- Hero -->
  <header class="members-hero">
    <div class="members-hero__inner">
      <div class="members-hero__brand">
        <div class="members-hero__icon" aria-hidden="true">
          <i class="pi pi-users"></i>
        </div>
        <div class="members-hero__text">
          <span class="members-hero__eyebrow">{{ 'MEMBER_LIST.PAGE_SUBTITLE' | translate }}</span>
          <h1 class="members-hero__title">{{ 'MEMBER_LIST.PAGE_TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="members-hero__meta">
        <span class="members-chip">
          <i class="pi pi-id-card"></i>
          {{ 'MEMBER_LIST.RECORDS_TAG' | translate: { count: memberCount } }}
        </span>
        <p-button data-tour="members-add" [label]="'MEMBER_LIST.ADD_MEMBER' | translate" icon="pi pi-plus" iconPos="right"
          severity="secondary" [outlined]="true" styleClass="members-hero__cta" (click)="onAddMember()" />
      </div>
    </div>
  </header>

  <!-- Filtros FOCNA (fila superior) -->
  <section class="members-focna-bar" aria-label="Filtros FOCNA" data-tour="members-focna">
    <h2 class="members-focna-bar__title">{{ 'MEMBER_LIST.FOCNA_SECTION_TITLE' | translate }}</h2>
    <div class="members-focna-bar__chips" role="navigation">
      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'cuna'" (click)="onCardFilter('cuna')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-heart"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_CUNA' | translate }}</span>
        </span>
        <span class="members-filter__count members-filter__count--amber">{{ focnaCunaCount }}</span>
      </button>

      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'parvulos'" (click)="onCardFilter('parvulos')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-sun"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_PARVULOS' | translate }}</span>
        </span>
        <span class="members-filter__count">{{ focnaParvulosCount }}</span>
      </button>

      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'primarios'" (click)="onCardFilter('primarios')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-book"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_PRIMARIOS' | translate }}</span>
        </span>
        <span class="members-filter__count members-filter__count--brand">{{ focnaPrimariosCount }}</span>
      </button>

      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'principiantes'" (click)="onCardFilter('principiantes')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-pencil"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_PRINCIPIANTES' | translate }}</span>
        </span>
        <span class="members-filter__count">{{ focnaPrincipiantesCount }}</span>
      </button>

      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'preadolescentes'" (click)="onCardFilter('preadolescentes')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-users"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_PREADOLESCENTES' | translate }}</span>
        </span>
        <span class="members-filter__count members-filter__count--success">{{ focnaPreadolescentesCount }}</span>
      </button>

      <button type="button" class="members-filter members-filter--chip"
        [class.members-filter--active]="activeCard === 'adolescentes'" (click)="onCardFilter('adolescentes')">
        <span class="members-filter__main">
          <span class="members-filter__icon"><i class="pi pi-star"></i></span>
          <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FOCNA_ADOLESCENTES' | translate }}</span>
        </span>
        <span class="members-filter__count members-filter__count--brand">{{ focnaAdolescentesCount }}</span>
      </button>
    </div>
  </section>

  <div class="members-layout">
    <!-- Sidebar filtros -->
    <aside class="members-sidebar">
      <article class="members-panel members-panel--sidebar">
        <header class="members-panel__head">
          <div class="members-panel__icon members-panel__icon--brand">
            <i class="pi pi-filter"></i>
          </div>
          <div class="members-panel__titles">
            <h2 class="members-panel__title">{{ 'MEMBER_LIST.FILTERS_TITLE' | translate }}</h2>
          </div>
        </header>
        <div class="members-panel__body members-panel__body--filters">
          <div class="members-filters" role="navigation" aria-label="Filtros de miembros" data-tour="members-filters">
            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'todos'"
              (click)="onCardFilter('todos')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-users"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_REGISTERED' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--amber">{{ memberCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'miembros'"
              (click)="onCardFilter('miembros')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-user-plus"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_MEMBERS' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--brand">{{ miembrosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'hombres'"
              (click)="onCardFilter('hombres')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-mars"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_MEN' | translate }}</span>
              </span>
              <span class="members-filter__count">{{ hombresCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'mujeres'"
              (click)="onCardFilter('mujeres')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-venus"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_WOMEN' | translate }}</span>
              </span>
              <span class="members-filter__count">{{ mujeresCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'familias'"
              (click)="onCardFilter('familias')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-home"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_FAMILIES' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--brand">{{ familiasCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'activos'"
              (click)="onCardFilter('activos')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-check-circle"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_ACTIVE' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--success">{{ activosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'inactivos'"
              (click)="onCardFilter('inactivos')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-times-circle"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_INACTIVE' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--danger">{{ inactivosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'disciplinados'"
              (click)="onCardFilter('disciplinados')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-exclamation-circle"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_DISCIPLINE' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--danger">{{ disciplinadosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'bautizados'"
              (click)="onCardFilter('bautizados')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-verified"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_BAPTIZED' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--brand">{{ bautizadosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'noBautizados'"
              (click)="onCardFilter('noBautizados')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-user"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_NOT_BAPTIZED' | translate }}</span>
              </span>
              <span class="members-filter__count">{{ noBautizadosCount }}</span>
            </button>

            <button type="button" class="members-filter" [class.members-filter--active]="activeCard === 'visitantes'"
              (click)="onCardFilter('visitantes')">
              <span class="members-filter__main">
                <span class="members-filter__icon"><i class="pi pi-id-card"></i></span>
                <span class="members-filter__label">{{ 'MEMBER_LIST.CARD_VISITORS' | translate }}</span>
              </span>
              <span class="members-filter__count members-filter__count--brand">{{ visitantesCount }}</span>
            </button>
          </div>
        </div>
      </article>
    </aside>

    <!-- Contenido principal -->
    <div class="members-main">
      <article class="members-panel">
        <header class="members-panel__head members-panel__head--toolbar">
          <div class="members-panel__icon members-panel__icon--accent">
            <i class="pi pi-list"></i>
          </div>
          <div class="members-panel__titles">
            <h2 class="members-panel__title">{{ titleKey | translate }}</h2>
            <p class="members-panel__desc">{{ 'MEMBER_LIST.RECORDS_TAG' | translate: { count: total } }}</p>
          </div>
          <div class="members-toolbar__actions">
            <p-button icon="pi pi-file-pdf" [label]="'MEMBER_LIST.EXPORT_PDF' | translate"
              (click)="exportMembersToPDF()" size="small" severity="danger" [outlined]="true" />
            <p-button icon="pi pi-calendar" [label]="'MEMBER_LIST.CERT_TITHE' | translate"
              (click)="openReportDialog()" size="small" severity="secondary" [outlined]="true" />
            <p-iconfield class="members-search" data-tour="members-search">
              <p-inputicon class="pi pi-search" />
              <input type="text" pInputText [placeholder]="'MEMBER_LIST.SEARCH_PLACEHOLDER' | translate"
                (input)="applyGlobalFilter($event)" />
            </p-iconfield>
          </div>
        </header>

        <div class="members-panel__body members-panel__body--flush">
          <!-- Tabla de miembros -->
          <div class="members-content-view" [hidden]="familias">
            <p-table #dt [value]="rows" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
              [tableStyle]="{ 'min-width': '50rem' }" [rowsPerPageOptions]="[5, 10, 20]"
              [exportHeader]="'customExportHeader'"
              [currentPageReportTemplate]="'MEMBER_LIST.PAGE_REPORT' | translate"
              [globalFilterFields]="['nombres', 'apellidos', 'tipo', 'estadoParticipacion']"
              styleClass="members-table">

              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="nombres">{{ 'MEMBER_LIST.TH_NAME' | translate }} <p-sortIcon field="nombres"></p-sortIcon></th>
                  <th pSortableColumn="tipo">{{ 'MEMBER_LIST.TH_TYPE' | translate }} <p-sortIcon field="tipo"></p-sortIcon></th>
                  <th pSortableColumn="estadoParticipacion">{{ 'MEMBER_LIST.TH_STATUS' | translate }} <p-sortIcon field="estadoParticipacion"></p-sortIcon></th>
                  <th pSortableColumn="estadoEspiritual">{{ 'MEMBER_LIST.TH_BAPTISM' | translate }} <p-sortIcon field="estadoEspiritual"></p-sortIcon></th>
                  <th style="width: 10rem">{{ 'MEMBER_LIST.TH_ACTIONS' | translate }}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-member>
                <tr [class.members-row--inactive]="member.tipo === 'Retirado'">
                  <td>
                    <div class="members-name">{{ member.nombres }}</div>
                    <div class="members-surname">{{ member.apellidos }}</div>
                  </td>
                  <td>{{ displayTipo(member.tipo) }}</td>
                  <td>
                    <p-tag [value]="displayEstadoParticipacion(member.estadoParticipacion)"
                      [severity]="getStatus(member.estadoParticipacion)" />
                  </td>
                  <td>{{ displayBautismo(member) }}</td>
                  <td>
                    <div class="members-actions">
                      <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info"
                        [pTooltip]="'MEMBER_LIST.TOOLTIP_VIEW' | translate" tooltipPosition="top"
                        (click)="onEditMember(member.id)" />
                      @if (member.tipo !== 'Retirado') {
                      <p-button icon="pi pi-ban" [rounded]="true" [text]="true" severity="danger"
                        [pTooltip]="'MEMBER_LIST.TOOLTIP_DEACTIVATE' | translate" tooltipPosition="top"
                        (click)="confirmarInactivarMiembro(member)" />
                      } @else {
                      <p-button icon="pi pi-check-circle" [rounded]="true" [text]="true" severity="success"
                        [pTooltip]="'MEMBER_LIST.TOOLTIP_ACTIVATE' | translate" tooltipPosition="top"
                        (click)="confirmarActivarMiembro(member)" />
                      }
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    <div class="members-empty">
                      <i class="pi pi-search"></i>
                      <p>{{ 'MEMBER_LIST.EMPTY_TABLE' | translate }}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <!-- Vista familias -->
          <div class="members-content-view members-content-view--families" [hidden]="!familias">
            <div class="row g-3">
              @for (fam of familiasRow; track fam.familiaId ?? $index) {
              <div class="col-xl-4 col-lg-6 col-md-6">
                <div class="family-card">
                  <div class="family-header">
                    <div class="family-header__inner">
                      <div class="family-icon">
                        <i class="pi pi-home"></i>
                      </div>
                      <div class="family-header__text">
                        <h3 class="family-name" [title]="fam.nombreFamilia">
                          {{ fam.nombreFamilia || ('MEMBER_LIST.FAMILY_UNNAMED' | translate) }}
                        </h3>
                        <span class="family-meta">{{ 'MEMBER_LIST.FAMILY_MEMBER_COUNT' | translate: { count: (fam.hijos?.length || 0) + 2 } }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="family-body">
                    <div class="parents-section">
                      <div class="parent-card">
                        <div class="parent-avatar-wrapper">
                          <img [src]="fam.padre?.photoUrl || 'assets/avatar.png'" (error)="onImgError($event)"
                            class="parent-avatar" loading="lazy" alt="" />
                          <div class="gender-badge male"><i class="pi pi-mars"></i></div>
                        </div>
                        <div class="parent-info">
                          <div class="parent-name">{{ fam.padre?.nombres?.split(' ')[0] || ('MEMBER_LIST.PARENT_NAME_FALLBACK' | translate) }}</div>
                          <div class="parent-age"><i class="pi pi-calendar"></i>{{ fam.padre?.fechaNacimiento | age }}</div>
                          <div class="parent-role">{{ 'MEMBER_LIST.ROLE_FATHER' | translate }}</div>
                        </div>
                      </div>

                      <div class="parent-card">
                        <div class="parent-avatar-wrapper">
                          <img [src]="fam.madre?.photoUrl || 'assets/avatar.png'" (error)="onImgError($event)"
                            class="parent-avatar" loading="lazy" alt="" />
                          <div class="gender-badge female"><i class="pi pi-venus"></i></div>
                        </div>
                        <div class="parent-info">
                          <div class="parent-name">{{ fam.madre?.nombres?.split(' ')[0] || ('MEMBER_LIST.MOTHER_NAME_FALLBACK' | translate) }}</div>
                          <div class="parent-age"><i class="pi pi-calendar"></i>{{ fam.madre?.fechaNacimiento | age }}</div>
                          <div class="parent-role">{{ 'MEMBER_LIST.ROLE_MOTHER' | translate }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="divider">
                      <span class="divider-text">{{ 'MEMBER_LIST.DIVIDER_CHILDREN' | translate }}</span>
                      <span class="divider-badge">{{ fam.hijos?.length || 0 }}</span>
                    </div>

                    <div class="children-section">
                      @if (fam.hijos && fam.hijos.length > 0) {
                      <div class="children-slider-wrapper">
                        <button type="button" class="slider-nav prev" (click)="scrollChildren($event, 'left')"
                          [attr.aria-label]="'MEMBER_LIST.ARIA_PREV' | translate">
                          <i class="pi pi-chevron-left"></i>
                        </button>
                        <div class="children-slider" #childrenSlider>
                          @for (h of fam.hijos; track h.id ?? $index) {
                          <div class="child-card">
                            <div class="child-avatar-wrapper">
                              <img [src]="h.photoUrl || 'assets/avatar.png'" (error)="onImgError($event)"
                                class="child-avatar" loading="lazy" alt="" />
                            </div>
                            <div class="child-info">
                              <div class="child-name" [title]="h.nombres">{{ h.nombres?.split(' ')[0] || ('MEMBER_LIST.CHILD_NAME_FALLBACK' | translate) }}</div>
                              <div class="child-age"><i class="pi pi-calendar"></i>{{ h.fechaNacimiento | age }}</div>
                            </div>
                          </div>
                          }
                        </div>
                        <button type="button" class="slider-nav next" (click)="scrollChildren($event, 'right')"
                          [attr.aria-label]="'MEMBER_LIST.ARIA_NEXT' | translate">
                          <i class="pi pi-chevron-right"></i>
                        </button>
                      </div>
                      } @else {
                      <div class="no-children">
                        <i class="pi pi-info-circle"></i>
                        <span>{{ 'MEMBER_LIST.NO_CHILDREN' | translate }}</span>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              } @empty {
              <div class="col-12">
                <div class="members-empty members-empty--large">
                  <i class="pi pi-home"></i>
                  <h3>{{ 'MEMBER_LIST.EMPTY_FAMILIES_TITLE' | translate }}</h3>
                  <p>{{ 'MEMBER_LIST.EMPTY_FAMILIES_DESC' | translate }}</p>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>
<p-toast></p-toast>
<p-dialog [header]="'MEMBER_LIST.DIALOG_ANNUAL_TITLE' | translate" [(visible)]="showReportDialog" [modal]="true"
  [style]="{ width: '400px' }" [draggable]="false" [resizable]="false">
  <div class="d-flex flex-column gap-3 py-3">
    <div class="d-flex flex-column gap-2">
      <label class="fw-bold">{{ 'MEMBER_LIST.SELECT_YEAR' | translate }}</label>
      <p-select [options]="yearsReport" [(ngModel)]="selectedYearReport" optionLabel="label" optionValue="value"
        [placeholder]="'MEMBER_LIST.YEAR_PLACEHOLDER' | translate" class="w-100" [style]="{'width':'100%'}"></p-select>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-4">
      <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" (click)="showReportDialog = false" [text]="true"></p-button>
      <p-button [label]="'MEMBER_LIST.GENERATE_REPORT' | translate" severity="primary" (click)="generateAnnualReport()"
        [loading]="generatingReport" icon="pi pi-file-pdf"></p-button>
    </div>
  </div>
</p-dialog>
